<h2 class="dashboard-title" *ngIf="configurations?.['dashboard-name']">
    {{ configurations['dashboard-name'] }}
</h2>

@if(!!configurations?.filters) {
<app-global-filter [config]="configurations?.filters"></app-global-filter>
}

<div>
  @for (item of configurations?.pageContent; track $index) {
    <div class="row">
      <h4 class="title">{{ item?.title }}</h4>

      @for (column of item?.columns; track $index) {
        <div class="col {{ column?.class }}">
          <!-- If column is a widget -->
          @if (column?.type) {
            <app-widget-renderer [charts]="column"></app-widget-renderer>
          }

          <!-- Nested rows inside column -->
          @if (column?.rows?.length > 0) {
            @for (nestedItem of column.rows; track $index) {
              
              <!-- If nestedItem is a widget (has type) -->
              @if(nestedItem?.type) {
                <div class="col {{ nestedItem?.class }}">
                  <app-widget-renderer [charts]="nestedItem"></app-widget-renderer>
                </div>
              }

              <!-- If nestedItem is a row (has columns) -->
              @if(nestedItem?.columns?.length > 0) {
                <div class="row">
                  <h4 class="title">{{ nestedItem?.title }}</h4>
                  @for (nestedCol of nestedItem.columns; track $index) {
                    <div class="col {{ nestedCol?.class }}">
                      <app-widget-renderer [charts]="nestedCol"></app-widget-renderer>
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      }
    </div>
  }
</div>
